var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0268 3.88C11.6135 3.88 8.02678 7.46667 8.02678 11.88V15.7333C8.02678 16.5467 7.68012 17.7867 7.26678 18.48L5.73345 21.0267C4.78678 22.6 5.44012 24.3467 7.17345 24.9333C12.9201 26.8533 19.1201 26.8533 24.8668 24.9333C26.4801 24.4 27.1868 22.4933 26.3068 21.0267L24.7734 18.48C24.3734 17.7867 24.0268 16.5467 24.0268 15.7333V11.88C24.0268 9.53934 23.008 7.42506 21.392 5.9587C19.9702 4.66859 18.0861 3.88 16.0268 3.88Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4934 4.26667C18.0801 4.14667 17.6534 4.05334 17.2134 4C15.9334 3.84 14.7067 3.93334 13.5601 4.26667C13.9467 3.28 14.9067 2.58667 16.0267 2.58667C17.1467 2.58667 18.1067 3.28 18.4934 4.26667Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0269 25.4133C20.0269 27.6133 18.2269 29.4133 16.0269 29.4133C14.9335 29.4133 13.9202 28.96 13.2002 28.24C12.4802 27.52 12.0269 26.5067 12.0269 25.4133",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.f1791da0.svg";
export { ForwardRef as ReactComponent };